package pl.decks.chartjs.jsConstructors

internal fun jso(block: dynamic.() -> Unit): dynamic {
    val obj = js("{}")
    block(obj)
    return obj
}
